export const FORM_BY_DEFAULT = 'contacter_le_club_form';
// export const FORM_BY_DEFAULT = 'nouveau-form-contacter-le-club';
export const LINK_BY_DEFAULT = 'nous-contacter';
export const TITLE_BY_DEFAULT = 'Contacter le club';
export const PATH_TO_FORMS = '/contact/';

export const SUBJECT_FIELD_NAME = 'ffr-subject';

export const FILE_INPUT_1 = 'ffr-contact_file';
export const FILE_INPUT_2 = 'ffr-contact_file-2';
export const FILE_FORMAT_ERROR_MESSAGE = 'Le format du fichier est incorrect.';

// ! @todo : formulaire-ligue === candidature spontanée => à voir avec Quentin
export const FORMS_WITH_FIELD_CONTAINER_DIV_INPUT_ONLY = ['contacter_le_club_form', 'formulaire-ligue'];
